"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePropsFromContext = void 0;
function makePropsFromContext(context, ownProps, mapContextToProps) {
    var propsForDispatch = {};
    if (mapContextToProps) {
        propsForDispatch = mapContextToProps(context, ownProps);
    }
    return propsForDispatch;
}
exports.makePropsFromContext = makePropsFromContext;
exports.default = makePropsFromContext;
